import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    class: "PopupHeadline px-2 py-4 bg-brand_beige_light text-center",
    style: { "position": "sticky", "z-index": "2", "top": "0" }
};
const _hoisted_2 = ["onClick"];
import eventBus from '@/services/EventBus';
import { ref, onMounted } from 'vue';
// POPUPS wohnen in der popups.html.twig !!!!
// Button-Sample zum öffnen eines, bzw. dieses Popups:
// <open-popup-button popup-name="openRegisterPopup"> <b>LOGIN</b> </open-popup-button>
export default /*@__PURE__*/ _defineComponent({
    __name: 'RegisterPopup',
    setup(__props) {
        onMounted(() => {
            eventBus.on('openRegisterPopup', responseData);
            eventBus.on('closeRegisterPopup', closePopup);
        });
        const openPopup = ref(false);
        const serverData = ref('');
        function responseData(data) {
            serverData.value = data;
            openPopup.value = true;
        }
        function closePopup() {
            openPopup.value = false;
        }
        return (_ctx, _cache) => {
            const _component_register_form = _resolveComponent("register-form");
                                                                  
                                                                      
            return (_openBlock(), _createBlock(_component_v_dialog, {
                class: "registerPopup",
                modelValue: openPopup.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((openPopup).value = $event)),
                width: "600",
                "max-height": "90vh"
            }, {
                default: _withCtx(({ isActive }) => [
                    _createVNode(_component_v_card, null, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "h5-responsive strong p-0 m-0 d-inline-bloc" }, "mySwooop - Registrieren!", -1)),
                                _createElementVNode("i", {
                                    onClick: ($event) => (isActive.value = false),
                                    class: "icon-cancel pointerhover float-right pr-2"
                                }, null, 8, _hoisted_2)
                            ]),
                            _createVNode(_component_register_form)
                        ]),
                        _: 2
                    }, 1024)
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});


/* Vuetify */
import { VCard as _component_v_card } from "vuetify/components/VCard"
import { VDialog as _component_v_dialog } from "vuetify/components/VDialog"

